import { render, staticRenderFns } from "./PcPcmRegnTap2Table1.vue?vue&type=template&id=6e296f52&"
import script from "./PcPcmRegnTap2Table1.vue?vue&type=script&lang=js&"
export * from "./PcPcmRegnTap2Table1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports